import { IconProps } from '.';

const StatesIcon = ({
  color = 'var(--color-ui-icon-primary)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 47 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5796 2.64551L46.0963 7.16218L44.1148 13.1066L41.2132 16.7336L42.8351 19.1665L39.4419 24.2563L44.1887 33.7498H36.6484L32.4817 29.5831H29.5018L28.4161 31.2116V36.2498H19.9817L14.7905 31.0585L4.61774 26.8199L0.0390625 18.5783L1.93461 4.36168L16.449 7.08312H30.9161L33.9648 9.3696L36.0929 8.30553L36.9262 4.9722L41.5796 2.64551ZM39.0727 6.69405L38.2394 10.0274L33.7008 12.2966L30.0828 9.58312H16.2166L4.06435 7.30457L2.62656 18.088L6.38122 24.8463L16.2085 28.9411L21.0172 33.7498H25.9161V30.4547L28.1638 27.0831H33.5172L37.6839 31.2498H40.1436L36.557 24.0767L39.8305 19.1665L38.1191 16.5993L41.8841 11.893L43.236 7.83741L41.086 5.68741L39.0727 6.69405Z"
        fill={color}
      />
    </svg>
  );
};

export default StatesIcon;
